import { Icon, IconsEnum } from 'components/Icons';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { setSaldoVisibility } from 'features/dashboard/dashboardSlice';
import styles from './SaldoHeader.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useInternalSession } from 'hooks/useInternalSession';
import useWindowSize from 'hooks/useWindowSize';

export type SaldoHeaderProps = {
  refetchWallet: () => void;
};

export const SaldoHeader = ({ refetchWallet }: SaldoHeaderProps) => {
  const labelAggiorna = useGetLabelByKey('aggiorna');
  const labelIlMioSaldo = useGetLabelByKey('il-mio-saldo');
  const labelContoSnai = useGetLabelByKey('conto-snai');
  const { session } = useInternalSession();
  const { isMobile } = useWindowSize();

  const dispatch = useAppDispatch();
  const isSaldoVisibile = useTypedSelector((state) => state.dashboard.isSaldoVisible);
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <button
          className={styles.buttonIconEye}
          type="button"
          onClick={() => dispatch(setSaldoVisibility(!isSaldoVisibile))}
        >
          <Icon
            iconId={isSaldoVisibile ? IconsEnum.EYE : IconsEnum.EYE_OFF}
            color="var(--color-primary)"
            className={styles.iconEye}
          />
        </button>
        <span>{labelIlMioSaldo}</span>
      </div>
      <div className={styles.textContainer}>
        <p className={styles.text}>
          {labelContoSnai} <span className={styles.highlighted}>{session?.user?.contractCode}</span>
        </p>
        <button type="button" onClick={() => refetchWallet()} className={styles.button}>
          <span className={styles.iconContainer}>
            <Icon iconId={IconsEnum.RELOAD_SPIN} color="var(--color-primary)" className={styles.icon} />
          </span>
          {!isMobile && <span className={styles.label}>{labelAggiorna!}</span>}
        </button>
      </div>
    </div>
  );
};
